import { apiCall } from "../../services/api-service.js";

const get = (endpoint) => apiCall("get", endpoint);
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);

export const getPRDetailsApi = async (id) => {
  try {
    return await get(`get_purchase_request/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitPurchaseQuotationAPI = async (body) => {
  try {
    return await post("purchase_quotation", body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVendorAddress = async (id) => {
  try {
    return await post("check_vendor_address", { vendor_id: id });
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getPQViewDetailsApi = async (id) => {
  try {
    return await get(`purchase_quotation/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const quotationStatusUpdateAPI = async (id, body) => {
  try {
    return await put(`purchase_quotation/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const poConvertAPI = async (id) => {
  try {
    return await put(`purchase_quotation/confirm/${id}`, {});
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
